import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Crown } from 'lucide-react';
import NewsletterModal from './NewsletterModal';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [newsletterOpen, setNewsletterOpen] = useState(false);

  // Listen for newsletter button clicks from floating button
  React.useEffect(() => {
    const handleOpenModal = () => setNewsletterOpen(true);
    window.addEventListener('openNewsletterModal', handleOpenModal);
    return () => window.removeEventListener('openNewsletterModal', handleOpenModal);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Join Us', path: '/app' },
    { name: 'Explore', path: '/explore' },
    { name: 'Events', path: '/events' },
    { name: 'Blog', path: '/blog' },
    { name: 'About', path: '/about' },
  ];

  return (
    <>
      <header
        className="fixed left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-gray-800 transition-[top] duration-200"
        style={{ top: 'var(--pt-offset, 0px)' }}
      >
        <nav className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 group">
              <img
                src="/popcrown-crown-red.png"
                alt=""
                aria-hidden="true"
                className="w-9 h-9 object-contain crown-pulse"
              />
              <span className="text-2xl font-bold text-white group-hover:text-[#E10600] transition-colors">
                PopCrown
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white hover:text-[#E10600] transition-colors font-medium"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://members.popcrownofficial.com/auth/sign-in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#E10600] transition-colors font-medium"
              >
                Sign In
              </a>
              <button
                onClick={() => setNewsletterOpen(true)}
                className="btn-gold text-sm px-6 py-2"
                aria-label="Subscribe to newsletter"
              >
                Newsletter
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-[#E10600] p-2"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-gray-800 pt-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block py-3 text-white hover:text-[#E10600] transition-colors font-medium"
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://members.popcrownofficial.com/auth/sign-in"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileMenuOpen(false)}
                className="block py-3 text-white hover:text-[#E10600] transition-colors font-medium"
              >
                Sign In
              </a>
              <button
                onClick={() => {
                  setNewsletterOpen(true);
                  setMobileMenuOpen(false);
                }}
                className="btn-gold text-sm px-6 py-2 mt-4 w-full"
                aria-label="Subscribe to newsletter"
              >
                Newsletter
              </button>
            </div>
          )}
        </nav>
      </header>

      {/* Newsletter Modal */}
      <NewsletterModal open={newsletterOpen} onClose={() => setNewsletterOpen(false)} />
    </>
  );
};

export default Header;